/**
 * Format-Utilities — konsistente Zahlen-, Währungs- und Datums-Ausgabe
 * (Deutscher Standard: Punkt als Tausendertrenner, Komma als Dezimaltrenner).
 *
 * Kanonische API — von überall importieren, KEINE lokalen ``toFixed()``+``€``
 * mehr. Vermeidet Inkonsistenzen wie ``1234.56 €`` vs. ``1.234,56 €``.
 */

const EUR_FMT = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUM_FMT_2 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUM_FMT_0 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Formatiert einen Betrag als "1.234,56 €" (deutsch). Null/undefined/NaN → "0,00 €".
 * @param {number|string|null|undefined} value
 * @returns {string}
 */
export function formatEuro(value) {
  const n = Number(value);
  return EUR_FMT.format(Number.isFinite(n) ? n : 0);
}

/**
 * Nur die Zahl ohne Währungs-Symbol, 2 Nachkommastellen, deutsches Format.
 * Beispiel: 1234.5 → "1.234,50"
 */
export function formatNumberDe(value, decimals = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) return decimals ? "0,00" : "0";
  return (decimals === 0 ? NUM_FMT_0 : NUM_FMT_2).format(n);
}

/**
 * Alias für Rückwärts-Kompat (kürzer). Deutsches Euro-Format.
 */
export const eur = formatEuro;
